import { render } from "./Perfil.vue?vue&type=template&id=0676bb70"
import script from "./Perfil.vue?vue&type=script&lang=js"
export * from "./Perfil.vue?vue&type=script&lang=js"

import "./Perfil.vue?vue&type=style&index=0&id=0676bb70&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__